import { Services } from "./services";

export class SeoMarkup {
    isPrimaryDomain: boolean;
    primaryDomainWhitelist = ['com', 'dev', 'local'];

    constructor(protected services: Services) {
        this.isPrimaryDomain = this.checkIsPrimaryDomain();
    }

    checkIsPrimaryDomain() {
        const hostname = window.location.hostname;

        return this.primaryDomainWhitelist.some(item => hostname.endsWith(`.${item}`));
    }

    createCanonicalLink(data: { url: string }) {
        const tag = document.createElement('link');

        tag.rel = 'canonical';
        tag.href = data.url;

        return tag;
    }

    createAlternateLink(data: { url: string; lang: string }) {
        const tag = document.createElement('link');

        tag.rel = 'alternate';
        tag.href = data.url;
        tag.hreflang = data.lang;

        return tag;
    }

    normalizeApiRoute(route: string) {
        const preparedRoute = route.startsWith('/') ? route : `/${route}`;

        return preparedRoute.endsWith('/') ? preparedRoute.slice(0, -1) : preparedRoute;
    }

    buildAbsoluteUrl(path: string) {
        return new URL(path, window.location.origin).toString();
    }

    getLinks(dataset: SeoMarkupDataset) {
        if (this.isLangRouteType(dataset.type)) {
            return this.getLinksWithLang(dataset);
        }

        return null;
    }

    getLinksWithLang(dataset: SeoMarkupDataset) {
        const canonical = this.parseApiRoute(dataset.canonical, dataset.type);
        const alternates = dataset
            .alternates
            ?.map(route => this.parseApiRoute(route, dataset.type)!)
            .filter(item => {
                if (!item || (canonical && item.url === canonical.url)) {
                    return false;
                }

                return true;
            }) ?? [];

        if (canonical && alternates.length > 0) {
            alternates.unshift(canonical);
        }

        return {
            canonical,
            alternates,
        };
    }

    parseApiRoute(route: string, type: 'product' | 'category' | 'brand') {
        const normalized = this.normalizeApiRoute(route);
        const segments = normalized.split('/').filter(item => item.length);

        if (this.isLangRouteType(type)) {
            const lang = segments[0];

            return {
                url: this.buildAbsoluteUrl(normalized),
                lang,
            };
        }

        return null;
    }

    isLangRouteType(type: string) {
        return type === 'product' || type === 'category' || type === 'brand' || type === 'static';
    }
}

type SeoMarkupDatasetBase = {
    canonical: string;
    alternates: string[];
};

export type SeoMarkupDataset = SeoMarkupDatasetBase & {
    type: 'product' | 'category' | 'brand' | 'static';
};
